module.exports = "/_next/static/images/412d77549c31b0bd8a0d6d6ee6e25eda-moneyboxes-left-desktop.jpg";